var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, "max-width": "80%", fixedActions: "" },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "mb-4" },
                [
                  _c("Title", {
                    attrs: {
                      title: "Ver detalhes",
                      subtitle: _vm.asset.nome_ativo || "",
                      underlined: ""
                    }
                  }),
                  _c("AssetHeader", {
                    staticClass: "mt-2",
                    attrs: { asset: _vm.asset, ctx: _vm.fichaCtx }
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        },
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("AssetActionsFooter", {
                staticClass: "mt-4",
                attrs: {
                  asset: _vm.asset,
                  "show-serie-historica":
                    _vm.isPersonalizado && !_vm.$currentUser().IS_CLIENTE,
                  "show-edit-ativo": Boolean(_vm.editAtivo),
                  "show-edit-composicao":
                    _vm.isFundo &&
                    Boolean(_vm.asset.id_ativo) &&
                    _vm.$isWhitelabel() &&
                    _vm.canShowSettings &&
                    !_vm.$currentUser().IS_CLIENTE
                },
                on: {
                  close: close,
                  "open-serie-historica": _vm.openSerieHistorica,
                  "edit-asset": _vm.editAsset,
                  "edit-composicao": _vm.editarComposicao,
                  "open-asset-events": _vm.openAssetEvents,
                  "open-movimentacoes": _vm.openMovimentacoes
                }
              })
            ]
          }
        }
      ])
    },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "details-asset details-asset__skeleton p-5" },
            [
              _c("BaseLoadingSkeleton", {
                staticClass: "mb-4",
                attrs: { height: "96px" }
              }),
              _c("BaseLoadingSkeleton", {
                staticClass: "mb-4",
                attrs: { height: _vm.alturaDoGrafico }
              }),
              _c("BaseLoadingSkeleton", { attrs: { height: "180px" } })
            ],
            1
          )
        : _vm._e(),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "details-asset p-5" },
            [
              _vm.recotizacaoProcessando
                ? _c(
                    "BaseAlert",
                    {
                      staticClass: "my-2",
                      attrs: { icon: "info", "icon-color": "info" }
                    },
                    [
                      _c("span", { staticClass: "text-normal" }, [
                        _vm._v(
                          " A cotização deste ativo está sendo processada. Os avisos serão atualizados em instantes. "
                        )
                      ])
                    ]
                  )
                : _vm._l(_vm.camposFaltantesEntries, function(aviso, ind) {
                    return _c(
                      "BaseAlert",
                      {
                        key: "aviso-" + ind,
                        staticClass: "my-2",
                        attrs: { icon: "warning", "icon-color": "warning" },
                        scopedSlots: _vm._u(
                          [
                            _vm.actionsAlerts.includes(aviso[0])
                              ? {
                                  key: "button",
                                  fn: function() {
                                    return [
                                      _c(
                                        "BaseButton",
                                        {
                                          staticClass: "mx-10",
                                          attrs: {
                                            small: "",
                                            dark: "",
                                            outline: "",
                                            "min-width": "80px"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.acaoAviso(aviso[0])
                                            }
                                          }
                                        },
                                        [
                                          _c("icon-svg", {
                                            attrs: { name: "plus", size: 16 }
                                          }),
                                          _vm._v(" Movimentação ")
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              : null
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c("span", { staticClass: "text-normal" }, [
                          _vm._v(_vm._s(aviso[1]))
                        ])
                      ]
                    )
                  }),
              _c("AssetKpis", {
                attrs: {
                  asset: _vm.asset,
                  serie: _vm.assetSeries,
                  loading: _vm.loadingSeries
                }
              }),
              _c("AssetPerformanceChart", {
                key: _vm.asset.id,
                staticClass: "mb-4",
                attrs: {
                  series: _vm.serieDoGrafico,
                  movements: _vm.movements,
                  proventos: _vm.proventos,
                  splits: _vm.splits,
                  loading: _vm.loadingSeries,
                  erro: _vm.assetSeriesErro,
                  period: _vm.chartPeriod,
                  "benchmarks-selecionados": _vm.benchmarksSelecionados,
                  moeda: _vm.asset.moeda || ""
                },
                on: {
                  "change-benchmarks": _vm.onBenchmarksChange,
                  "period-change": _vm.onChartPeriodChange,
                  "marker-click": _vm.onMarkerClick
                }
              }),
              _c(
                "div",
                [
                  _c(
                    "v-tabs",
                    {
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c("v-tab", { key: "Dados Gerais" }, [
                        _vm._v(" Dados Gerais")
                      ]),
                      _c("v-tab", { key: "Movimentações" }, [
                        _vm._v("Movimentações")
                      ]),
                      _vm.hasEventos
                        ? _c("v-tab", { key: "Eventos" }, [_vm._v("Eventos")])
                        : _vm._e(),
                      _vm.isFundo && _vm.asset.id_ativo
                        ? _c(
                            "v-tab",
                            {
                              key: "Composição fundo",
                              attrs: { href: "#composicao" }
                            },
                            [_vm._v(" Composição ")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "v-tabs-items",
                    {
                      staticClass: "details-asset__tabs-content",
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c(
                        "v-tab-item",
                        { key: "Dados Gerais" },
                        [
                          _c("AssetFicha", {
                            staticClass: "mt-3",
                            attrs: { asset: _vm.asset, ctx: _vm.fichaCtx }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        { key: "Movimentações" },
                        [
                          _c("AssetTabMovimentacoes", {
                            attrs: {
                              "sugestoes-por-movimentacao":
                                _vm.sugestoesPorMovimentacao,
                              asset: _vm.asset,
                              client: _vm.client,
                              "bus-left": _vm.busLeft,
                              movimentacoes: _vm.movimentacoes,
                              movements: _vm.movements,
                              "show-alert-fill-pu": _vm.showAlertFillPu
                            },
                            on: {
                              "remove-movimentacao": _vm.openModalRemove,
                              "open-movimentacoes": _vm.openMovimentacoes,
                              "revisar-sugestoes":
                                _vm.abrirSugestoesDaMovimentacao
                            }
                          })
                        ],
                        1
                      ),
                      _vm.hasEventos
                        ? _c(
                            "v-tab-item",
                            { key: "Eventos" },
                            [
                              _c("AssetTabEventos", {
                                attrs: {
                                  asset: _vm.asset,
                                  proventos: _vm.proventos,
                                  splits: _vm.splits,
                                  loading: _vm.loadingEvents
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isFundo && _vm.asset.id_ativo
                        ? _c(
                            "v-tab-item",
                            {
                              key: "Composição fundo",
                              attrs: { value: "composicao" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "details-asset__composicao" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex mt-2" },
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: "mdi-information-outline",
                                          size: 16
                                        }
                                      }),
                                      _c("p", { staticClass: "mt-2 mb-2" }, [
                                        _c("small", [
                                          _vm._v(
                                            " As informações de rentabilidade e volatilidade utilizadas são sempre do ativo macro, ou seja, não são detalhadas conforme os produtos da composição do ativo. "
                                          )
                                        ])
                                      ])
                                    ],
                                    1
                                  ),
                                  _c("ComposicaoFundo", {
                                    attrs: { ativo: _vm.asset }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }